import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";

const BRAND_PLANS = [
  { name: "Free", price: "£0", period: "", fee: "20%", note: "Up to 2 hires a month", key: "free" },
  { name: "Starter", price: "£29", period: "/mo", fee: "15%", note: "Unlimited hires + analytics", key: "starter", highlight: true },
  { name: "Pro", price: "£99", period: "/mo", fee: "10%", note: "Team seats + priority support", key: "pro" },
  { name: "Founding", price: "£249", period: "/yr", fee: "10%", note: "Fee locked for life", key: "founding" },
];

export default function HomePricing() {
  return (
    <section className="px-6 lg:px-10 py-20 border-t border-white/5" data-testid="landing-pricing-section">
      <div className="max-w-6xl mx-auto">
        <div className="text-xs uppercase tracking-[0.3em] text-zinc-500 mb-3">What it costs</div>
        <h2 className="font-display font-bold text-3xl md:text-4xl tracking-tighter mb-3">Brands pay the fee. Creators keep 100%.</h2>
        <p className="text-zinc-400 mb-8 max-w-2xl">
          You agree a price with the creator, fund it through Stripe, and Nexus adds one platform fee on top — 20% on the free plan, down to 10% on Pro. There's nothing to pay until a deal is agreed.
        </p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3" data-testid="landing-pricing-grid">
          {BRAND_PLANS.map((p) => (
            <div key={p.key} className={`rounded-2xl p-5 hairline ${p.highlight ? "bg-white/[0.05] ring-1 ring-nexus-pink/40" : "bg-white/[0.02]"}`} data-testid={`landing-plan-${p.key}`}>
              <div className="flex items-baseline justify-between">
                <div className="text-xs uppercase tracking-widest text-zinc-400">{p.name}</div>
                {p.highlight && <span className="text-[9px] uppercase tracking-widest text-nexus-pink">Most popular</span>}
              </div>
              <div className="font-display font-bold text-3xl text-white mt-2">{p.price}<span className="text-sm text-zinc-500 font-normal">{p.period}</span></div>
              <div className="mt-3 inline-flex items-center gap-1.5 rounded-full bg-emerald-500/10 border border-emerald-500/30 px-2.5 py-1 text-[11px] text-emerald-200"><Check className="h-3 w-3" /> {p.fee} fee per deal</div>
              <div className="text-xs text-zinc-500 mt-3">{p.note}</div>
            </div>
          ))}
        </div>
        <div className="mt-6 flex flex-col sm:flex-row sm:items-center gap-3 text-sm">
          <div className="text-zinc-400" data-testid="landing-pricing-example">Example: agree £500 with a creator on the free plan → you pay £600, the creator receives the full £500.</div>
          <Link to="/pricing" className="inline-flex items-center gap-2 text-nexus-blue hover:underline sm:ml-auto" data-testid="landing-pricing-link">Full pricing, incl. Creator Pro <ArrowRight className="h-4 w-4" /></Link>
        </div>
      </div>
    </section>
  );
}
